var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMicrophoneEmpty = function SvgMicrophoneEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#microphone-empty_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 18.667a3.983 3.983 0 0 0 3.987-4l.013-8c0-2.213-1.787-4-4-4s-4 1.787-4 4v8c0 2.213 1.787 4 4 4Zm7.067-4c0 4-3.387 6.8-7.067 6.8s-7.067-2.8-7.067-6.8H6.667c0 4.547 3.626 8.307 8 8.96V28h2.666v-4.373c4.374-.64 8-4.4 8-8.96h-2.266Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "microphone-empty_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgMicrophoneEmpty;